var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsPlusButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99998,
    cy: 7.72343,
    r: 7.59574,
    fill: "#FBBC55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72336 4.82985C8.72336 4.43032 8.39948 4.10645 7.99996 4.10645C7.60043 4.10645 7.27655 4.43032 7.27655 4.82985V7.00006H5.10634C4.70681 7.00006 4.38293 7.32394 4.38293 7.72347C4.38293 8.12299 4.70681 8.44687 5.10634 8.44687H7.27655V10.6171C7.27655 11.0166 7.60043 11.3405 7.99996 11.3405C8.39948 11.3405 8.72336 11.0166 8.72336 10.6171V8.44687H10.8936C11.2931 8.44687 11.617 8.12299 11.617 7.72347C11.617 7.32394 11.2931 7.00006 10.8936 7.00006H8.72336V4.82985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsPlusButton);
export default __webpack_public_path__ + "static/media/es_plus_button.d4ffdf31c9f997bcb726fc611b4c6a2f.svg";
export { ForwardRef as ReactComponent };